import { render, staticRenderFns } from "./formView.vue?vue&type=template&id=b1dd4448&"
import script from "./formView.vue?vue&type=script&lang=js&"
export * from "./formView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports